import React, { useState } from 'react'
import { composeId, convertToKebabCase } from '../../utils'
import FormControl from '../form-control'
import Icon from '../icon'
import { Area, Label, Counter, Hint, IconWrapper, LabelWrapper } from './styles'

interface Props {
  defaultValue?: string
  value?: string
  'data-qa'?: string
  disabled?: boolean
  label?: string
  limit?: number
  onChange: Function
  hint?: string
  name?: string
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>
}

export default function Textarea(props: Props): JSX.Element {
  const [value, setValue] = useState<string>(props.defaultValue ?? props.value)
  const limitCounter = composeCounter(value, props.limit)
  const isValid = shouldValidate(value, props.limit)
  const id = composeId(props.label)
  const dataQa = `textarea-${convertToKebabCase(props.label)}`
  const hasHint = Boolean(props.hint)

  return (
    <>
      <FormControl>
        <Label html-for={id}>
          <span> {props.label} </span>

          {props.limit && (
            <Counter className={!isValid && 'error'}>{limitCounter}</Counter>
          )}
        </Label>

        <LabelWrapper>
          <Area
            className={!props.disabled && !isValid ? 'negative' : ''}
            data-qa={props['data-qa'] || dataQa}
            id={id}
            onChange={(event) => {
              const currentValue = event.target.value
              setValue(currentValue)
              props.onChange(currentValue)
            }}
            disabled={props.disabled}
            value={props.value}
            defaultValue={props.defaultValue}
            name={props.name}
            onBlur={props.onBlur}
            maxLength={props.limit}
          />

          {!isValid && (
            <IconWrapper>
              <Icon name={'close'} color={'feedbackColorNegativePure'} />
            </IconWrapper>
          )}
        </LabelWrapper>
      </FormControl>

      {hasHint && (
        <Hint className={!props.disabled && !isValid ? 'negative' : ''}>
          {props.hint}
        </Hint>
      )}
    </>
  )
}

export const composeCounter = (text: string, limit: number): string => {
  const length: number = text?.length || 0
  return `${length}/${limit}`
}

export const shouldValidate = (text: string, limit?: number): boolean => {
  return !limit || text?.length <= limit
}
